  import {gql} from 'apollo-boost'

  export default gql`
  mutation ($username: String!, $password: String!){
    authenticate(username: $username, password: $password)
  }
  `